"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountsResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const general_1 = require("./general");
const primitives_1 = require("./primitives");
exports.CountsResponseSchema = (0, primitives_1.StrictObject)({
    counts: typebox_1.Type.Record(typebox_1.Type.String(), general_1.CountSchema),
});
